import { Rating as MuiRating, RatingProps } from '@mui/material';

export const Rating = ({ children, ...otherProps }: RatingProps) => {
  return <MuiRating {...otherProps}>{children}</MuiRating>;
};
